import { render, staticRenderFns } from "./MessageParamBinding.vue?vue&type=template&id=59d1cd40&scoped=true&"
import script from "./MessageParamBinding.vue?vue&type=script&lang=js&"
export * from "./MessageParamBinding.vue?vue&type=script&lang=js&"
import style0 from "./MessageParamBinding.vue?vue&type=style&index=0&id=59d1cd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1cd40",
  null
  
)

export default component.exports